module.exports = __webpack_public_path__ + "img/activeTitle.8f19d510.png";